export default __webpack_public_path__ + "8dc8954a9d62c4b675de80046d9c4fb6.pdf";